// extracted by mini-css-extract-plugin
export default {"overview":"overview_overview__cT9Ln","overview__row":"overview_overview__row__NtEuT","overview__row__title":"overview_overview__row__title__ELI6V"};